import React, { useContext, useEffect, useState } from 'react';
import ModalContainer from "../../common/modal_container";
import girl_1 from "../../../_asset/source/girl_1.png"
import { CasinoImageInterface, exportNewCasinoJson, otherCasino } from "../../../data/gameData_casino";
import { loadingContext } from "../../provider/game_loading_provider";
import { FloatLayout } from "../pop_component/float_layout";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import AudioPlayer from "../../layout/audio_player";
import { lobbyModalContext } from "../../provider/lobby_modal_provider";
import { Logo_1, Logo_2 } from '../../common/logo';

function CasinoPopup({ title }: { title: string }) {
    const [popShow, setPopShow] = useState<boolean>(false)

    return (
        <>
            <p className={"--pointer"} onClick={e => setPopShow(true)}>{title}</p>
            <CasinoModal popShow={popShow}
                setPopShow={setPopShow} title={title} />
        </>
    );
}

export default CasinoPopup;

export function CasinoModal({ popShow, setPopShow, title }: { popShow: boolean; setPopShow: Function; title: string }) {

    return (
        <ModalContainer show={popShow}
            setShow={setPopShow}
            closeBtn={true}
            // title={'카지노'}
            className={"casino-pop"}
        >
            {/*카지노*/}
            <CasinoNewPopup />
        </ModalContainer>
    )
}

function CasinoNewPopup() {
    const [state, setState] = useState<boolean>(false)
    const [focusTitle, setFocusTitle] = useState<string>('')
    const [focusImg, setFocusImg] = useState<string>('')
    const [oneFocus, setOneFocus] = useState(false)
    const [deviceWidth, setDeviceWidth] = useState<number>(window.innerWidth)
    const [perViewSize, setPerViewSize] = useState<number>(7)

    const roundList = exportNewCasinoJson.slice(0, 8);
    const floatList = exportNewCasinoJson.slice(8);

    window.onresize = function () {
        setDeviceWidth(window.innerWidth)
    }
    useEffect(() => {
        setTimeout(() => {
            setState(true)
        }, 200)
    }, [])
    useEffect(() => {
        if (deviceWidth > 1200) {
            setPerViewSize(7)
        } else if (deviceWidth > 992) {
            setPerViewSize(6)
        } else if (deviceWidth > 768) {
            setPerViewSize(4)
        } else if (deviceWidth > 576) {
            setPerViewSize(3)
        } else {
            setPerViewSize(2)
        }
        // console.log(perViewSize)
    }, [deviceWidth])
    return (
        <>
            <div className={'game-pop-layout'}>
                <div className='casino-header'>
                    <Logo_1 />
                </div>
                <FloatLayout girl={girl_1} />
                {
                    state ?
                        <div className={"casino-list"}>
                            <div className={`focus-title`}>
                                {
                                    focusTitle
                                        ? <div className={'hover-logo-action'}>
                                            <img src={focusImg} className={'company-img'} alt="asd" />
                                            <div className={'company-logo'}>
                                                <img src={focusTitle} alt="asd" />
                                            </div>
                                        </div>
                                        : <div className={'default'}>
                                            <Logo_2 />
                                        </div>
                                }
                            </div>
                            <div className="company-list casino"
                                onMouseOut={e => setOneFocus(false)}>
                                {
                                    roundList?.map((casino, index) => {
                                        return (
                                            <CasinoNewPopupItem key={index}
                                                casino={casino}
                                                setOneFocus={setOneFocus}
                                                isOneFocus={oneFocus}
                                                setFocusTitle={setFocusTitle}
                                                setFocusImg={setFocusImg} />
                                        )
                                    })
                                }
                            </div>
                        </div>
                        : <></>
                }
            </div>
            {
                state ?
                    <div className={'slot-float-list-layout'}
                        onMouseOut={e => setOneFocus(false)}>
                        <Swiper
                            className={'company-list casino'}
                            slidesPerView={perViewSize}
                            loop={true}
                            navigation={{
                                enabled: true,
                                nextEl: ".swiper-arrow-next",
                                prevEl: ".swiper-arrow-prev",
                            }}
                            modules={[Navigation]}
                        >
                            {
                                floatList.map((slot, index) => (
                                    <SwiperSlide key={index}>
                                        <CasinoNewPopupItem casino={slot}
                                            setOneFocus={setOneFocus}
                                            isOneFocus={oneFocus}
                                            setFocusTitle={setFocusTitle}
                                            setFocusImg={setFocusImg}
                                            isBottom
                                        />
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                        <div className={'swiper-arrow-next'}>
                            <div className={'arrow'}></div>
                            {/*<FontAwesomeIcon icon={faArrowRight} />*/}
                        </div>
                        <div className={'swiper-arrow-prev'}>
                            <div className={'arrow'}></div>
                            {/*<FontAwesomeIcon icon={faArrowLeft} />*/}
                        </div>
                    </div>
                    : <></>
            }
        </>
    )
}

type gameItemsClassType = "" | "disabled" | "focus"
function CasinoNewPopupItem({ casino, setFocusTitle, setFocusImg, setOneFocus, isOneFocus, }:
    {
        casino: CasinoImageInterface,
        setFocusTitle: Function,
        setFocusImg: Function,
        setOneFocus: Function,
        isOneFocus: boolean,
    }) {
    const [focus, setFocus] = useState<boolean>(false)
    const [state, setState] = useState<gameItemsClassType>("")

    const { SetLoadingPop } = useContext(loadingContext)
    const [audioPlay, setAudioPlay] = useState<boolean>(false)
    const { SetLobbyShow, SetVendor, SetType } = useContext(lobbyModalContext)

    useEffect(() => {
        if (isOneFocus && focus) {
            // mouseover
            setState('focus')
        } else if (isOneFocus && !focus) {
            // other items
            setState('disabled')
        } else {
            setState('')
        }
    }, [focus, isOneFocus])
    return (
        <div onClick={e => {
            if (otherCasino.includes(casino.vendor)) {
                SetVendor(casino.vendor)
                SetType('casino')
                SetLobbyShow()
            } else {
                // SetLoadingPop(true)
                // ErrorVendorCheck(casino.vendor, casino.id, 'casino')
                //     .finally(()=> SetLoadingPop(false))
                window.open(`/gameLobby/${casino.vendor}/?type=casino&uid=${casino.id}&vendor=${casino.vendor}`,
                    `${casino.vendor}_${casino.id}`, `width=1200 height=640`)
            }
        }}
            onMouseOver={e => {
                setAudioPlay(true)
                setFocusTitle(casino.logo)
                setFocusImg(casino.img)
                setFocus(true)
                setOneFocus(true)
            }}
            onMouseOut={e => {
                setAudioPlay(false)
                setFocusTitle('')
                setFocusImg('')
                setFocus(false)
            }}
            className={`company casino ${state}`}>
            <div className={'inner-border'}></div>
            <div className={'inner-image'}>
                <div className={'overlay-light'}></div>
                <img src={casino.img} className={'image'} alt="" />
                {/* <img src={casino.overlay} className={'overlay'} alt=""/> */}
            </div>
            <span>{casino.name}</span>

            <AudioPlayer type={"company"} play={audioPlay} />
            <ShadowLight />
        </div>
    )
}
CasinoNewPopupItem.defaultProps = {
    isBottom: false
}

export function ShadowLight() {
    return (
        <div className={'shadow-light'}>
            <div className={'span-1'}></div>
            <div className={'span-2'}></div>
            <div className={'span-3'}></div>
            {/*<div className={'span-4'}></div>*/}
            {/*<div className={'span-5'}></div>*/}
        </div>
    )
}

